import { isTiersVolumeProduct } from '@weft/services';
import type { UsageProduct, UsageProductInput } from '@weft/types';
import { outersect } from '@weft/utils';

export function getSplitVolumeUsageProducts<Product extends UsageProduct | UsageProductInput>(usageProducts: Product[]) {
  const volumeBasedProducts = usageProducts.filter(isTiersVolumeProduct);
  const nonVolumeBasedProducts = outersect(usageProducts, volumeBasedProducts);

  return { volumeBasedProducts, nonVolumeBasedProducts } as const;
}